import { Component, Input, OnInit } from '@angular/core';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-video-card',
  templateUrl: './video-card.component.html',
  styleUrls: ['./video-card.component.css']
})
export class VideoCardComponent implements OnInit {

  @Input() cardID: number;
  @Input() cardTitle: any;
  @Input() videoData:any = [];
  noOfViews:any;
  constructor(public selfLearnService: SelfLearnService) { }

  ngOnInit(): void {
    this.noOfViews = this.getNoOfViews();
    console.log('videoData',this.videoData);
  }

  displayTime(duration:any){
    return this.selfLearnService.secondsToTime(duration);
  }

  getNoOfViews(){
    return this.selfLearnService.generateRandomNumber();
  }

  displayImage(url:any){
    return url?.replaceAll('https', 'http');
  }

}
